import {course_createCourseClass_Api, course_deleteCourseClass_Api, course_editCourseClass_Api,} from 'apis'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {useState} from 'react'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from 'views/AppLocals/factory/createNotification'
import {NullAsDefault} from 'views/Shared'

export const useCourseClassApi = ({
  onCreated = NullAsDefault,
  onUpdated = NullAsDefault,
  onDeleted = NullAsDefault,
  autoRefresh = true,
}) => {
  const t = useTranslate()

  const [refreshKey, setRefreshKey] = useState()

  const onError = notifyOnError(t)

  const onRefresh = () => {
    if (autoRefresh) {
      setRefreshKey(Date.now())
    }
  }

  const { handleAsyncAction: onCreate } = useAsyncAction({
    apiInfo: course_createCourseClass_Api,
    onError,
    onSuccess: () => {
      successNotify(NotificationActionTypes.CREATE, t)
      onRefresh()
      onCreated()
    },
  })

  const { handleAsyncAction: onUpdate } = useAsyncAction({
    apiInfo: course_editCourseClass_Api,
    onError,
    onSuccess: () => {
      successNotify(NotificationActionTypes.UPDATE, t)
      onRefresh()
      onUpdated()
    },
  })

  const { handleAsyncAction: onDelete } = useAsyncAction({
    apiInfo: course_deleteCourseClass_Api,
    onError,
    onSuccess: () => {
      successNotify(NotificationActionTypes.DELETE, t)
      onRefresh()
      onDeleted()
    },
  })

  return {
    onCreate,
    onUpdate,
    onDelete,
    onRefresh,
    refreshKey,
  }
}
